import { useToggle } from 'ahooks'
import { Modal } from 'antd'
import * as React from 'react'
import { useHistory } from 'react-router-dom'

import { routes } from '@/routes'

import { GroupsList, GroupsListProps } from './groups-list.component'

interface GroupsListModalProps extends Partial<GroupsListProps> {
  title: string
}

export const GroupsListModal: React.FC<GroupsListModalProps> = ({
  title,
  showSearch,
  userId,
  type,
  filter,
  children,
  showPin,
  showFollow,
  nameClickable,
  onClickGroup,
}) => {
  const history = useHistory()
  const [visible, { toggle }] = useToggle()

  children = React.cloneElement(children as any, {
    onClick: toggle,
  })

  onClickGroup ||= (groupId: number) => {
    toggle()
    history.push(routes.groups.page(groupId))
  }

  return (
    <>
      {children}
      <Modal
        visible={visible}
        footer={null}
        title={title}
        onCancel={() => toggle()}
        destroyOnClose
        bodyStyle={{ padding: 0 }}
      >
        <GroupsList
          type={type}
          showPin={showPin}
          showFollow={showFollow}
          nameClickable={nameClickable}
          userId={userId}
          filter={filter}
          showSearch={showSearch}
          onClickGroup={onClickGroup}
        />
      </Modal>
    </>
  )
}
